import { IBaseAction } from "../../../../common/interfaces/IBaseAction";
export enum Keys {
  LOADROOMS = "react/rooms/LOADROOMS",
  LOADROOMS_FULFILLED = "react/rooms/LOADROOMS_FULFILLED",
  LOADROOMS_REJECTED = "react/rooms/LOADROOMS_REJECTED",
  SELECTROOM = "react/rooms/SELECTROOM",
  CHANGEROOMINEDIT = "react/rooms/CHANGEROOMINEDIT",
  CHANGEROOMDESCRIPTION = "react/rooms/CHANGEROOMDESCRIPTION",
  CHANGEROOMACCESSRULE = "react/rooms/CHANGEROOMACCESSRULE",
  UPDATEROOMDESCRIPTION = "react/rooms/UPDATEROOMDESCRIPTION",
  UPDATEROOMDESCRIPTION_FULFILLED = "react/rooms/UPDATEROOMDESCRIPTION_FULFILLED",
  UPDATEROOMDESCRIPTION_REJECTED  = "react/rooms/UPDATEROOMDESCRIPTION_REJECTED ",
  EDITROOM = "react/rooms/EDITROOM",
  EDITROOM_FULFILLED = "react/rooms/EDITROOM_FULFILLED",
  EDITROOM_REJECTED = "react/rooms/EDITROOM_REJECTED ",
  LOADROOMDETAIL = 'react/rooms/LOADROOMDETAIL',
  LOADROOMDETAIL_FULFILLED = 'react/rooms/LOADROOMDETAIL_FULFILLED',
  LOADROOMDETAIL_REJECTED = 'react/rooms/LOADROOMDETAIL_REJECTED',
  CREATEROOM = 'react/rooms/CREATEROOM',
  CREATEROOM_FULFILLED = 'react/rooms/CREATEROOM_FULFILLED',
  CREATEROOM_REJECTED = 'react/rooms/CREATEROOM_REJECTED',
  SAVEROOM = 'react/rooms/SAVEROOM',
  SAVEROOM_FULFILLED = 'react/rooms/SAVEROOM_FULFILLED',
  SAVEROOM_REJECTED = 'react/rooms/SAVEROOM_REJECTED',
  OTHER_ACTION = "react/rooms/__any_other_action__",
}

export type Types = IBaseAction<Keys>;
